import { render, staticRenderFns } from "./RolesOverviewSection.vue?vue&type=template&id=83be2924"
import script from "./RolesOverviewSection.vue?vue&type=script&lang=js"
export * from "./RolesOverviewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports